
import { Grid, Card, CardContent, Typography } from '@mui/material'
import { AnimatedSuccessTick, Alert } from 'frame/components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const FBTWebFormFinish = ({ fbtWebForm }) => {
  return (
    <Card
      sx={{
        marginY: 5,
        paddingTop: 5,
        paddingBottom: '300px',
        width: 960,
        '@media (max-width:960px)': {
          width: '100%',
          margin: '20px 10px 0 10px',
        },
      }}>
      <CardContent>
        {!fbtWebForm ? (
          <Alert severity="error">
            {'Invalid token. This FBT Submissions link is invalid or has been expired'}
          </Alert>
        ) : (
          <Grid container spacing={3}>
            <Grid xs={12} item>
              <Typography
                sx={{
                  fontWeight: 'bold'
                }}
                gutterBottom variant="h4" align="center">
                Submission Completed
              </Typography>
              <Typography gutterBottom variant="body1" align="center">
                If changes are required, please contact your Fleet Controller
              </Typography>
            </Grid>
            <Grid xs={12} item>
              <AnimatedSuccessTick size={200} />
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}


FBTWebFormFinish.propTypes = {
  fbtWebForm: PropTypes.object,
}

const mapStateToProps = ({ fbtSubmissions }) => ({
  fbtWebForm: fbtSubmissions.fbtWebForm,
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(FBTWebFormFinish)
